import {
    Chart,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    TimeScale,
    Tooltip,
} from 'chart.js';
import 'chartjs-adapter-date-fns';

export function registerCharts(): void {
    Chart.register(
        TimeScale,
        LinearScale,
        LineController,
        LineElement,
        PointElement,
        Tooltip,
    );
}
